import styled from 'styled-components';
import Link from 'gatsby-link';
import { colorWithHover } from './animations';
import {
  red, white, blue, lighterBlue, teko, tekoLight, tekoMedium, roboto,
} from './theme';
import { mobile } from './breakpoints';

export const RTE = styled.div`
  margin-top: 30px;
  padding: 0;
  
  &.footer-modal {
    padding: 0 15px;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    ${tekoMedium}
    font-weight: normal;
    text-transform: uppercase;
    text-align: left;
    color: ${blue};
    margin-bottom: 20px;
    margin-top: 15px;
  }
  h2 {
    font-size: 58px;
    font-size: 3.5rem;
    line-height: 1;
    letter-spacing: 3.3px;
    letter-spacing: 0.20625rem;
  }
  h3 {
    font-size: 40px;
    font-size: 3rem;
    line-height: 40px;
    line-height: 2.5rem;
    letter-spacing: 1.7px;
    letter-spacing: 0.10625rem;
  }
  h4 {
    font-size: 36px;
    font-size: 2.5rem;
    line-height: 1;
    letter-spacing: 2.3px;
    letter-spacing: 0.14375rem;
  }

  p {
    margin-bottom: 10px;
  }

  li{
    ${roboto}
    font-size: 1rem;
    line-height: 1.5;
    margin-top: 3px;
    margin-bottom: 10px;

    > p {
      display: inline;
    }
  }
  
  ul{
    list-style: disc;
    list-style-position: inside;
  }


  @media (max-width: ${mobile.max}px) {
    h2 {
      font-size: 40px;
      font-size: 3.5rem;
      line-height: 1;
      letter-spacing: 3.3px;
      letter-spacing: 0.20625rem;
    }
    h3 {
      font-size: 36px;
      font-size: 3rem;
      line-height: 40px;
      line-height: 2.5rem;
      letter-spacing: 1.7px;
      letter-spacing: 0.10625rem;
    }
    h4 {
      font-size: 28px;
      font-size: 2.5rem;
      line-height: 1;
      letter-spacing: 2.3px;
      letter-spacing: 0.14375rem;
    }
  }
`;

export const Section = styled.section`
  background: url('${({ background }) => background}');
  background-size: cover;
  ${({ position }) => position && `background-position: ${position};`};
`;

export const Container = styled.section`
  background-size: cover;
  background-position: top center;
`;

export const BackgroundContainer = styled(Container)`
  background-size: cover;
  background-image: url('${({ src }) => src}');
`;

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  .careers__wrapper {
    iframe {
      max-width: 100%;
      min-width: 100%;
      width: 0;
    }
  }
`;

const whiteButtonStyling = `
  ${colorWithHover({
    color: white,
    inverse: blue,
    borderWidth: '2px',
  })}
  ${tekoLight}
  font-size: 28px;
  text-transform: uppercase;
  padding: 6px 10px 0px 10px;
  letter-spacing: 6px;

  span {
    margin-right: -6px;
    cursor: pointer;
  }

  &.xfl-button--header {
    padding: 10px 15px;
  }
`;

export const WhiteButton = styled(Link)`
  ${whiteButtonStyling}
`;

export const WhiteButtonDiv = styled.div`
  ${whiteButtonStyling}
`;

export const WhiteButtonExternal = styled.a`
  ${whiteButtonStyling}
`;

const blueButtonStyling = `
  ${colorWithHover({
    color: lighterBlue,
    inverse: white,
    borderWidth: '2px',
  })}
  ${tekoLight}
  font-size: 53px;
  text-transform: uppercase;
  padding: 6px 10px 3px 10px;
  letter-spacing: 6px;
  display: inline-block;
  padding-top: 12px;
  white-space: nowrap;

  ::before {
    content: '';
    height: 3px;
  }

  span {
    cursor: pointer;
    margin-right: -6px;
  }

  &.xfl-button--header {
    padding: 10px 15px;
  }

  .button-red {
    color: ${red};
  }

  @media (max-width: ${mobile.max}px) {
    font-size: 47px;
    padding-top: 8px;
  }
`;

export const BlueButton = styled(Link)`
  ${blueButtonStyling};
`;

export const BlueButtonExternal = styled.a`
  ${blueButtonStyling};
`;

export const Button = styled.button`
  ${blueButtonStyling};
  line-height: 1;
`;

export const LinkButton = styled(Link)`
  display: inline-block;
  background: none;
  ${teko}
  border: 1px solid ${red};
  border: .0625rem solid ${red};
  position: relative;
  overflow: hidden;
  color: ${white};
  cursor: pointer;
  font-size: 18px;
  letter-spacing: 1.89px;
  line-height: 11px;
  text-align: center;
  text-transform: uppercase;

  &::before {
    content: '';
    background: ${red};
    height: 100%;
    width: 100%;
    border: none;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    -webkit-transition: 0.15s width ease-in-out, 0s left;
    transition: 0.15s width ease-in-out, 0s left;
  }

  &:hover {
    webkit-transition: .5s all 0s cubic-bezier(0.23, 1, 0.32, 1),0.05s color,0s background;
    transition: .5s all 0s cubic-bezier(0.23, 1, 0.32, 1),0.05s color,0s background;

    &::before {
      left: 100%;
      width: 0;
      -webkit-transition: 0.15s left ease-in-out, 0s width 0.15s;
      transition: 0.15s left ease-in-out, 0s width 0.15s;
    }
  }
`;

export const ButtonInverse = styled(Button)`
  border: 1px solid ${red};
  border: 0.0625rem solid ${red};

  &::before {
    content: '';
    background: ${white};
    color: ${red};
    height: 100%;
    border: none;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 100%;
    width: 0;
    -webkit-transition: 0.15s left ease-in-out, 0s width 0.15s;
    transition: 0.15s left ease-in-out, 0s width 0.15s;
  }

  &:hover {
    webkit-transition: 0.5s all 0s cubic-bezier(0.23, 1, 0.32, 1), 0.05s color, 0s background;
    transition: 0.5s all 0s cubic-bezier(0.23, 1, 0.32, 1), 0.05s color, 0s background;

    &::before {
      width: 100%;
      left: 0;
      -webkit-transition: 0.15s width ease-in-out, 0s left;
      transition: 0.15s width ease-in-out, 0s left;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/utils/atoms.js